export default __webpack_public_path__ + "static/media/chemistry.b56acc80.png";